import { ResultOf } from 'gql.tada';
import { SourceType } from '../../../../components/WaterService/SourceTypePicker';
import { WaterSiteType } from '../../../../components/WaterSite/WaterSiteTypePicker';
import { gql } from '../../gql';

export const GET_WATER_SITE_IDS = gql(`
  query GetWaterSiteIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterSites(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`);

export const GET_WATER_SITES = gql(`
  query GetWaterSites(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterSites(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      siteNumber
      type
      lastSurveyDate
      nextSurveyDate
      surveyIntervalYears
      lastInspectionDate
      nextInspectionDate
      contact {
        id
        name
        firstName
        lastName
      }
      supervisor {
        id
        name
        firstName
        lastName
      }
      assignedTo {
        id
        name
        firstName
        lastName
      }
      address(required: true) {
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`);

export type WaterSiteItem = ResultOf<
  typeof GET_WATER_SITES
>['waterSites'][number];
